import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsEcommerceHelpersOysho } from '../helpers/brand-analytics-ecommerce.helpers.oy';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';
import { AnalyticsOyshoEventsTransformer } from '../helpers/brand-analytics-events.transformer.oy';
import { AnalyticsHelpersOysho } from '../helpers/brand-analytics.helpers.oy';
import { getDefaultAnalytics } from '../helpers/events.helper';

export const MiniwishlistEvents: AnalyticsBrandSettings = {
    miniwishlistCheckoutAnadirProductoCesta(data: AnalyticsEventData): AnalyticsGTMSettings {
        const { helpers, componentData, context } = data;
        const product = componentData.products?.[0];
        let partnumber;
        if (isDefined(product)) {
            partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: true});
        }
        const label = `${partnumber}`;

        const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'checkout', 'miniwishlist', 'anadir_producto_cesta', label);
        let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

        const dimensions: string [] = ['16', '17', '198', '20', '70', '71', '48', '58', '98'];
        if (isDefined(helpers)) {
            settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
        }
        settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceAdd(componentData, context);
        return settingsGTM;
    },

    miniwishlistWishlistAnadirTodoCesta(data: AnalyticsEventData): AnalyticsGTMSettings {
        const { componentData, context } = data;
        const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'wishlist', 'miniwishlist', 'anadir_todo_cesta');
        const settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
        settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceAdd(componentData, context);
        return settingsGTM;
    },

    miniwishlistWishlistVerTodos(data: AnalyticsEventData): AnalyticsGTMSettings {
        const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'wishlist', 'miniwishlist', 'ver_todos');
        return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    },

    miniwishlistWishlistEliminarProductoWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
        const { helpers, componentData } = data;
        const product = componentData.products?.[0];
        let partnumber;
        if (isDefined(product)) {
            partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
        }
        const label = `${partnumber}`;

        const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'checkout', 'miniwishlist', 'eliminar_producto_wishlist', label);
        let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

        const dimensions: string [] = ['20'];
        if (isDefined(helpers)) {
            settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
        }
        return settingsGTM;
    },
}